import { FC } from "react";
import { LoadOverlayProps } from "./types";
import { Loader } from "rsuite";
import styles from "./LoadOverlay.module.scss";

const LoadOverlay: FC<LoadOverlayProps> = ({
  open = false,
  size = "md",
  position = "absolute",
  message = "",
  loadingAnimation,
  messageStyle = {},
}) => {
  if (!open) return null;

  return (
    <div className={styles.load_overlay} style={{ position }}>
      {loadingAnimation ? loadingAnimation : <Loader size={size} />}
      {message !== "" && (
        <div style={messageStyle} className="__h3">
          {message}
        </div>
      )}
    </div>
  );
};

export default LoadOverlay;
